import React, { memo } from 'react';
import { ArrowRight, Check, BookOpen, Star, AlertCircle, Lightbulb, Users, GraduationCap } from 'lucide-react';
import { PurchaseNotification } from '../components/PurchaseNotification';
import { TestimonialCard } from '../components/TestimonialCard';
export function LandingPage() {
  const scrollToPurchase = () => {
    const element = document.getElementById('comprar');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const testimonials = [{
    name: 'Laura Fernández',
    role: 'Profesora de Física - Escuela Secundaria',
    location: 'Buenos Aires',
    quote: 'Antes sentía que hablaba otro idioma. Mis alumnos me miraban con cara de póker cuando explicaba cinemática. Ahora veo cómo se les iluminan los ojos cuando entienden el concepto antes de ver la fórmula.',
    transformation: 'Logré que el 90% del curso aprobara el último examen entendiendo lo que hacían.'
  }, {
    name: 'Martín Rodríguez',
    role: 'Docente Universitario - Ingeniería',
    location: 'Córdoba',
    quote: 'En la facultad asumimos que ya saben pensar, pero no es así. Este libro me dio las herramientas para construir ese puente que les faltaba. No bajé el nivel, al contrario, ahora puedo exigir más porque entienden la base.',
    transformation: 'Mis alumnos de primer año dejaron de abandonar la materia a mitad de cuatrimestre.'
  }, {
    name: 'Carolina Méndez',
    role: 'Profesora - Colegio Técnico',
    location: 'Rosario',
    quote: 'Estaba agotada de repetir lo mismo sin resultados. Sentía que la física se había vuelto odiosa para ellos. Con este enfoque, las clases fluyen y hasta se ríen mientras aprenden.',
    transformation: 'La participación en clase aumentó drásticamente, ahora preguntan con sentido.'
  }, {
    name: 'Diego Sánchez',
    role: 'Profesor - Facultad de Ciencias',
    location: 'Mendoza',
    quote: 'Llevo 20 años enseñando y pensaba que ya lo había visto todo. Física Sencilla me mostró que el problema no era la complejidad, sino cómo la presentaba. Es un cambio de paradigma total.',
    transformation: 'Recuperé la pasión por enseñar temas que ya me aburrían.'
  }, {
    name: 'Valeria Castro',
    role: 'Docente - Profesorado de Física',
    location: 'La Plata',
    quote: 'Lo uso con mis futuros docentes. Es fundamental que aprendan a enseñar así desde el principio. Si hubiese tenido esto cuando empecé, me habría ahorrado años de frustración.',
    transformation: 'Mis estudiantes del profesorado ahora tienen herramientas reales para sus prácticas.'
  }];
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 overflow-x-hidden" data-id="element-22">
      <PurchaseNotification data-id="element-23" />

      {/* Hero Section */}
      <header className="bg-gradient-to-b from-blue-900 to-blue-800 text-white pt-12 pb-20 px-4 relative overflow-hidden" data-id="element-24">
        <div className="absolute top-0 left-0 w-full h-full opacity-10 bg-[url('https://www.transparenttextures.com/patterns/graphy.png')]" data-id="element-25"></div>
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center relative z-10" data-id="element-26">
          <div className="space-y-6 text-center md:text-left" data-id="element-27">
            <div className="inline-block bg-blue-700/50 px-4 py-1.5 rounded-full text-blue-100 font-medium text-sm mb-2 border border-blue-500/30" data-id="element-28">
              Para docentes que quieren enseñar mejor
            </div>
            <h1 className="text-5xl md:text-6xl font-bold tracking-tight leading-tight" data-id="element-29">
              FÍSICA <span className="text-blue-300" data-id="element-30">SENCILLA</span>
            </h1>
            <p className="text-xl md:text-2xl text-blue-100 font-light leading-relaxed" data-id="element-31">
              El ebook que transforma cómo explicás física en secundaria y
              facultad.
            </p>
            <div className="flex flex-col gap-3 text-blue-200 font-medium" data-id="element-32">
              <div className="flex items-center gap-2 justify-center md:justify-start" data-id="element-33">
                <Check className="w-5 h-5 text-green-400" data-id="element-34" /> Sin bajar el nivel
              </div>
              <div className="flex items-center gap-2 justify-center md:justify-start" data-id="element-35">
                <Check className="w-5 h-5 text-green-400" data-id="element-36" /> Sin perder rigor
              </div>
              <div className="flex items-center gap-2 justify-center md:justify-start" data-id="element-37">
                <Check className="w-5 h-5 text-green-400" data-id="element-38" /> Sin improvisar
              </div>
            </div>
            <div className="pt-6" data-id="element-39">
              <button onClick={scrollToPurchase} className="bg-yellow-400 hover:bg-yellow-300 text-blue-900 font-bold py-4 px-8 rounded-lg shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 text-lg w-full md:w-auto flex items-center justify-center gap-2" data-id="element-40">
                Acceder a Física Sencilla <ArrowRight className="w-5 h-5" data-id="element-41" />
              </button>
            </div>
          </div>
          <div className="relative group cursor-pointer" onClick={scrollToPurchase} data-id="element-42">
            <div className="absolute inset-0 bg-blue-400 blur-3xl opacity-20 rounded-full group-hover:opacity-30 transition-opacity" data-id="element-43"></div>
            <img src="https://cdn.magicpatterns.com/uploads/4W7MTANASqYZPYgZ7sbUF7/ChatGPT_Image_Jan_18,_2026,_01_10_27_PM.png" alt="Física Sencilla Ebook Cover" className="relative w-full max-w-md mx-auto rounded-xl shadow-2xl transform group-hover:scale-105 transition-transform duration-500" data-id="element-44" />
          </div>
        </div>
      </header>

      {/* Problem Agitation Section */}
      <section className="py-20 px-4 bg-white" data-id="element-45">
        <div className="max-w-3xl mx-auto space-y-8 text-lg leading-relaxed text-gray-700" data-id="element-46">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-12" data-id="element-47">
            Hay una frustración que solo los docentes de física conocen
          </h2>

          <p data-id="element-48">Sabés física. La estudiaste. La entendés de verdad.</p>
          <p data-id="element-49">
            Podés resolver problemas. Podés seguir demostraciones. Podés ver
            conexiones que otros no ven.
          </p>

          <div className="bg-slate-50 border-l-4 border-blue-500 p-6 my-8 italic" data-id="element-50">
            <p className="font-medium text-slate-800" data-id="element-51">
              Pero cuando llega el momento de explicarla en clase… algo se
              rompe.
            </p>
          </div>

          <p data-id="element-52">
            Las miradas se pierden. Las preguntas no aparecen. El ritmo se
            vuelve forzado.
          </p>
          <p data-id="element-53">Y aunque nadie lo diga en voz alta, vos lo sentís.</p>
          <p data-id="element-54">
            Ese silencio incómodo. Esa sensación de estar explicando "para
            pocos". Ese pensamiento que vuelve una y otra vez:
          </p>

          <p className="text-center font-bold text-2xl text-blue-900 py-4" data-id="element-55">
            "Yo lo entiendo… ¿por qué ellos no?"
          </p>

          <p data-id="element-56">No es enojo. Es frustración silenciosa.</p>
          <p data-id="element-57">
            Porque vos sí te esforzás. Preparás clases. Buscás ejemplos.
            Intentás explicarlo de otra manera.
          </p>
          <p className="font-semibold" data-id="element-58">Y aun así, la física no llega.</p>
        </div>
      </section>

      {/* The Truth Section */}
      <section className="py-20 px-4 bg-slate-100" data-id="element-59">
        <div className="max-w-3xl mx-auto" data-id="element-60">
          <div className="bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-slate-200" data-id="element-61">
            <div className="flex items-center gap-3 mb-6" data-id="element-62">
              <AlertCircle className="w-8 h-8 text-red-500" data-id="element-63" />
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900" data-id="element-64">
                La verdad incómoda que casi nadie dice
              </h2>
            </div>

            <div className="space-y-6 text-lg text-gray-700" data-id="element-65">
              <p data-id="element-66">
                No es que tus alumnos no puedan. No es falta de capacidad. No es
                falta de estudio.
              </p>
              <p className="font-bold text-xl text-gray-900" data-id="element-67">
                El problema es otro.
              </p>
              <p data-id="element-68">
                La física suele enseñarse desde la lógica del experto, no desde
                la lógica del que está aprendiendo.
              </p>
              <p data-id="element-69">
                Se empieza por fórmulas, definiciones y resultados finales antes
                de que el alumno tenga una imagen clara de qué está pasando.
              </p>
              <p data-id="element-70">Y ahí se abre un abismo.</p>
              <p data-id="element-71">Vos sabés demasiado. Ellos todavía saben muy poco.</p>
              <p className="font-medium text-blue-800" data-id="element-72">
                Y ese salto no se salva con más fórmulas.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Desgaste Section */}
      <section className="py-20 px-4 bg-white" data-id="element-73">
        <div className="max-w-3xl mx-auto space-y-8 text-lg text-gray-700" data-id="element-74">
          <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-75">
            El desgaste invisible del docente de física
          </h2>

          <p data-id="element-76">La mayoría de los docentes de física no son malos docentes.</p>
          <p className="font-medium" data-id="element-77">Son docentes exigentes consigo mismos.</p>

          <p data-id="element-78">Les duele:</p>
          <ul className="space-y-3 pl-4" data-id="element-79">
            <li className="flex items-center gap-3" data-id="element-80">
              <span className="w-2 h-2 bg-red-400 rounded-full" data-id="element-81"></span> Ver
              alumnos perdidos
            </li>
            <li className="flex items-center gap-3" data-id="element-82">
              <span className="w-2 h-2 bg-red-400 rounded-full" data-id="element-83"></span> Repetir
              explicaciones sin efecto
            </li>
            <li className="flex items-center gap-3" data-id="element-84">
              <span className="w-2 h-2 bg-red-400 rounded-full" data-id="element-85"></span> Sentir
              que la física se convierte en memorización vacía
            </li>
          </ul>

          <p data-id="element-86">Con el tiempo aparece algo peor: el desgaste.</p>
          <p data-id="element-87">
            Preparar clases que no funcionan cansa. Explicar sin impacto
            desmotiva. Repetir sin comprensión agota.
          </p>

          <div className="bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-88">
            <p className="mb-4 font-medium" data-id="element-89">Y aparece el miedo silencioso:</p>
            <ul className="space-y-2 italic text-gray-600" data-id="element-90">
              <li data-id="element-91">"¿Me estoy volviendo un docente mecánico?"</li>
              <li data-id="element-92">"¿Estoy haciendo que odien la física?"</li>
              <li data-id="element-93">"¿Mi esfuerzo realmente genera impacto?"</li>
            </ul>
          </div>

          <p className="text-xl font-medium text-blue-900 text-center pt-4" data-id="element-94">
            La vocación sigue intacta. La energía, no siempre.
          </p>
        </div>
      </section>

      {/* Transformation Section */}
      <section className="py-20 px-4 bg-blue-900 text-white relative overflow-hidden" data-id="element-95">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-96"></div>
        <div className="max-w-4xl mx-auto relative z-10" data-id="element-97">
          <div className="text-center mb-16" data-id="element-98">
            <Lightbulb className="w-16 h-16 text-yellow-400 mx-auto mb-6" data-id="element-99" />
            <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-100">
              El momento en que todo cambia
            </h2>
            <p className="text-xl text-blue-100 max-w-2xl mx-auto" data-id="element-101">
              Física Sencilla nació en el aula. De un docente que dominaba la
              física, pero veía siempre el mismo resultado: Alumnos que
              aprobaban sin entender.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-102">
            <div className="space-y-6 text-lg text-blue-50" data-id="element-103">
              <p data-id="element-104">Hasta que cambió una sola pregunta.</p>
              <div className="space-y-4" data-id="element-105">
                <div className="bg-blue-800/50 p-4 rounded-lg border border-blue-700 line-through text-blue-300" data-id="element-106">
                  No fue: "¿Cómo explico este tema?"
                </div>
                <div className="bg-green-500/20 p-6 rounded-lg border border-green-400 text-white font-bold text-xl shadow-lg" data-id="element-107">
                  Fue: "¿Qué necesita entender primero el alumno para que esto
                  tenga sentido?"
                </div>
              </div>
              <p data-id="element-108">Ese cambio transformó las clases.</p>
              <p data-id="element-109">
                Aparecieron las preguntas. La comprensión real. Las fórmulas
                dejaron de ser un muro.
              </p>
              <p className="font-medium text-white" data-id="element-110">
                No porque se bajara el nivel, sino porque se construyó el camino
                mental antes del formalismo.
              </p>
            </div>
            <div className="bg-white/5 p-8 rounded-2xl backdrop-blur-sm border border-white/10" data-id="element-111">
              <h3 className="text-2xl font-bold mb-6 text-yellow-400" data-id="element-112">
                El problema real que nadie nombra
              </h3>
              <p className="mb-4" data-id="element-113">
                La mayoría de los materiales que usamos (libros universitarios,
                apuntes técnicos) tienen algo en común:
              </p>
              <p className="font-bold mb-4" data-id="element-114">
                Están escritos para expertos, no para aprendices.
              </p>
              <p className="mb-4" data-id="element-115">
                Asumen intuiciones que el alumno no tiene. Muestran resultados
                sin mostrar el proceso mental.
              </p>
              <p className="italic text-blue-200" data-id="element-116">
                Entonces el docente termina traduciendo en vivo, improvisando
                explicaciones, cargando con todo el peso. Eso cansa.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-20 px-4 bg-white" data-id="element-117">
        <div className="max-w-5xl mx-auto" data-id="element-118">
          <div className="text-center mb-16" data-id="element-119">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-120">
              ¿Qué es Física Sencilla?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-121">
              La pieza que falta: el puente conceptual entre el mundo cotidiano
              y el lenguaje formal.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center mb-16" data-id="element-122">
            <div className="order-2 md:order-1 cursor-pointer" onClick={scrollToPurchase} data-id="element-123">
              <img src="https://cdn.magicpatterns.com/uploads/4W7MTANASqYZPYgZ7sbUF7/ChatGPT_Image_Jan_18,_2026,_01_10_27_PM.png" alt="Física Sencilla Book" className="w-full max-w-md mx-auto rounded-xl shadow-2xl hover:scale-105 transition-transform duration-300" data-id="element-124" />
            </div>
            <div className="space-y-6 text-lg text-gray-700 order-1 md:order-2" data-id="element-125">
              <p data-id="element-126">
                Física Sencilla es un ebook pedagógico pensado específicamente
                para docentes de física de:
              </p>
              <ul className="grid grid-cols-1 gap-3 font-medium text-blue-900" data-id="element-127">
                <li className="flex items-center gap-2" data-id="element-128">
                  <GraduationCap className="w-5 h-5 text-blue-500" data-id="element-129" /> Educación
                  secundaria
                </li>
                <li className="flex items-center gap-2" data-id="element-130">
                  <Users className="w-5 h-5 text-blue-500" data-id="element-131" /> Profesorados
                </li>
                <li className="flex items-center gap-2" data-id="element-132">
                  <BookOpen className="w-5 h-5 text-blue-500" data-id="element-133" /> Primeros años
                  de facultad
                </li>
              </ul>
              <div className="bg-blue-50 p-6 rounded-lg border-l-4 border-blue-500 mt-6" data-id="element-134">
                <p className="font-bold text-blue-900 mb-2" data-id="element-135">
                  No es un libro de teoría. No es un tratado académico.
                </p>
                <p data-id="element-136">Es un recurso docente diseñado para ayudarte a:</p>
                <ul className="mt-3 space-y-2" data-id="element-137">
                  <li className="flex items-center gap-2" data-id="element-138">
                    <Check className="w-4 h-4 text-green-600" data-id="element-139" /> Explicar con
                    claridad
                  </li>
                  <li className="flex items-center gap-2" data-id="element-140">
                    <Check className="w-4 h-4 text-green-600" data-id="element-141" /> Construir
                    intuición conceptual
                  </li>
                  <li className="flex items-center gap-2" data-id="element-142">
                    <Check className="w-4 h-4 text-green-600" data-id="element-143" /> Introducir
                    fórmulas cuando ya tienen sentido
                  </li>
                  <li className="flex items-center gap-2" data-id="element-144">
                    <Check className="w-4 h-4 text-green-600" data-id="element-145" /> Mantener rigor
                    sin perder comprensión
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Benefits Grid */}
          <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-146">
            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-147">
              <div className="bg-blue-100 w-12 h-12 rounded-full flex items-center justify-center mb-4" data-id="element-148">
                <Lightbulb className="w-6 h-6 text-blue-600" data-id="element-149" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-150">
                Comprensión antes del cálculo
              </h3>
              <p className="text-gray-600" data-id="element-151">
                Cada tema parte de la intuición cotidiana y construye el
                concepto paso a paso. Formaliza recién cuando el alumno
                entiende.
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-152">
              <div className="bg-green-100 w-12 h-12 rounded-full flex items-center justify-center mb-4" data-id="element-153">
                <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-154" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-155">No baja el nivel</h3>
              <p className="text-gray-600" data-id="element-156">
                Baja la barrera de entrada. Es como mostrar el paisaje antes del
                mapa. Como traducir del lenguaje del experto al humano.
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-157">
              <div className="bg-purple-100 w-12 h-12 rounded-full flex items-center justify-center mb-4" data-id="element-158">
                <Star className="w-6 h-6 text-purple-600" data-id="element-159" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-160">Impacto real</h3>
              <p className="text-gray-600" data-id="element-161">
                Los alumnos entienden, participan y las fórmulas dejan de ser
                abstractas. Recuperás la sensación de impacto real.
              </p>
            </div>
          </div>

          <div className="text-center" data-id="element-162">
            <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-163">
              Qué empieza a pasar en tus clases
            </h3>
            <div className="flex flex-wrap justify-center gap-4 mb-8" data-id="element-164">
              <span className="bg-green-100 text-green-800 px-4 py-2 rounded-full font-medium flex items-center gap-2" data-id="element-165">
                <Check className="w-4 h-4" data-id="element-166" /> Los alumnos entienden
              </span>
              <span className="bg-green-100 text-green-800 px-4 py-2 rounded-full font-medium flex items-center gap-2" data-id="element-167">
                <Check className="w-4 h-4" data-id="element-168" /> Pueden explicar con sus palabras
              </span>
              <span className="bg-green-100 text-green-800 px-4 py-2 rounded-full font-medium flex items-center gap-2" data-id="element-169">
                <Check className="w-4 h-4" data-id="element-170" /> Las fórmulas cobran sentido
              </span>
              <span className="bg-green-100 text-green-800 px-4 py-2 rounded-full font-medium flex items-center gap-2" data-id="element-171">
                <Check className="w-4 h-4" data-id="element-172" /> La clase fluye
              </span>
            </div>
            <p className="text-xl italic text-gray-600 mb-8" data-id="element-173">
              Ese momento en el que alguien dice: "Ah… ahora sí entendí, profe."
            </p>
            <button onClick={scrollToPurchase} className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 px-10 rounded-lg shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 text-lg" data-id="element-174">
              Quiero lograr esto en mis clases
            </button>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-20 px-4 bg-gradient-to-b from-slate-50 to-blue-50" data-id="element-175">
        <div className="max-w-6xl mx-auto" data-id="element-176">
          <div className="text-center mb-16" data-id="element-177">
            <span className="bg-yellow-400 text-blue-900 font-bold px-4 py-1 rounded-full text-sm uppercase tracking-wide mb-4 inline-block" data-id="element-178">
              Oferta Especial
            </span>
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-179">
              Bonos Exclusivos
            </h2>
            <p className="text-xl text-gray-600" data-id="element-180">
              Incluidos GRATIS por el día de hoy con tu compra
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-181">
            {/* Bonus 1 */}
            <div className="group cursor-pointer" onClick={scrollToPurchase} data-id="element-182">
              <div className="relative overflow-hidden rounded-xl shadow-lg mb-4 bg-white" data-id="element-183">
                <div className="absolute top-4 right-4 bg-red-500 text-white font-bold px-3 py-1 rounded-full text-sm z-10" data-id="element-184">
                  GRATIS
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/iQzed4sL2Tpiq1cp3tjkyB/ChatGPT_Image_Jan_18,_2026,_01_34_22_PM.png" alt="Bono 1: Pack de Planificaciones" className="w-full h-auto transform group-hover:scale-105 transition-transform duration-500" data-id="element-185" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-186">
                Bono 1: Pack de Planificaciones
              </h3>
              <p className="text-gray-600" data-id="element-187">
                Listas para usar. Ahorrá horas de trabajo administrativo con
                plantillas probadas.
              </p>
            </div>

            {/* Bonus 2 */}
            <div className="group cursor-pointer" onClick={scrollToPurchase} data-id="element-188">
              <div className="relative overflow-hidden rounded-xl shadow-lg mb-4 bg-white" data-id="element-189">
                <div className="absolute top-4 right-4 bg-red-500 text-white font-bold px-3 py-1 rounded-full text-sm z-10" data-id="element-190">
                  GRATIS
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/sHJkofvXgVgUK9dmpofaBS/ChatGPT_Image_Jan_18,_2026,_01_34_30_PM.png" alt="Bono 2: Guía de Experimentos" className="w-full h-auto transform group-hover:scale-105 transition-transform duration-500" data-id="element-191" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-192">
                Bono 2: Experimentos Simples
              </h3>
              <p className="text-gray-600" data-id="element-193">
                De bajo costo. Ideales para escuelas con pocos recursos pero
                muchas ganas de aprender.
              </p>
            </div>

            {/* Bonus 3 */}
            <div className="group cursor-pointer" onClick={scrollToPurchase} data-id="element-194">
              <div className="relative overflow-hidden rounded-xl shadow-lg mb-4 bg-white" data-id="element-195">
                <div className="absolute top-4 right-4 bg-red-500 text-white font-bold px-3 py-1 rounded-full text-sm z-10" data-id="element-196">
                  GRATIS
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/9ATiwDKkDugz7GkZP1qruw/Quick_guide_para_ensenar_fisica.png" alt="Bono 3: Guía Rápida" className="w-full h-auto transform group-hover:scale-105 transition-transform duration-500" data-id="element-197" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-198">
                Bono 3: Guía Rápida
              </h3>
              <p className="text-gray-600" data-id="element-199">
                Cómo explicar física a estudiantes que odian la física.
                Estrategias de enganche inmediato.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 px-4 bg-white" data-id="element-200">
        <div className="max-w-6xl mx-auto" data-id="element-201">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-16" data-id="element-202">
            Lo que dicen otros docentes
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-203">
            {testimonials.map((testimonial, index) => <div key={index} className={index >= 3 ? 'lg:col-span-1 md:col-span-1' : ''} data-id="element-204">
                <TestimonialCard {...testimonial} data-id="element-205" />
              </div>)}
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section id="comprar" className="py-24 px-4 bg-blue-900 text-white relative overflow-hidden" data-id="element-206">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-20" data-id="element-207"></div>
        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-208">
          <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-209">
            Física Sencilla
          </h2>
          <p className="text-xl md:text-2xl text-blue-200 mb-12 max-w-2xl mx-auto" data-id="element-210">
            No para aprender más física. Sino para enseñarla mejor. Convertí
            conceptos complejos en comprensión real.
          </p>

          <div className="bg-white/10 backdrop-blur-md p-8 rounded-2xl border border-white/20 max-w-lg mx-auto transform hover:scale-105 transition-transform duration-300" data-id="element-211">
            <div className="flex flex-col items-center" data-id="element-212">
              <span className="text-blue-200 text-lg mb-2" data-id="element-213">
                Precio Regular:{' '}
                <span className="line-through decoration-red-400" data-id="element-214">$35,000</span>
              </span>
              <div className="flex items-baseline gap-2 mb-6" data-id="element-215">
                <span className="text-5xl font-bold text-white" data-id="element-216">$18,999</span>
                <span className="text-xl text-yellow-400 font-medium" data-id="element-217">ARS</span>
              </div>

              <a href="https://checkout.libraryebook.shop/cart/48233658089722:1" className="w-full bg-yellow-400 hover:bg-yellow-300 text-blue-900 font-bold py-4 px-8 rounded-lg shadow-lg hover:shadow-xl transition-all text-xl flex items-center justify-center gap-2 mb-4" data-id="element-218">
                Acceder Ahora <ArrowRight className="w-6 h-6" data-id="element-219" />
              </a>

              <div className="flex items-center gap-2 text-sm text-blue-200" data-id="element-220">
                <CheckCircle2 className="w-4 h-4 text-green-400" data-id="element-221" /> Acceso
                inmediato digital
              </div>
              <div className="flex items-center gap-2 text-sm text-blue-200 mt-1" data-id="element-222">
                <CheckCircle2 className="w-4 h-4 text-green-400" data-id="element-223" /> Incluye
                todos los bonos
              </div>
            </div>
          </div>

          <div className="mt-16 text-blue-300 text-sm max-w-2xl mx-auto border-t border-blue-800 pt-8" data-id="element-224">
            <p className="mb-4 font-bold text-lg text-white" data-id="element-225">
              La afirmación incómoda (pero liberadora)
            </p>
            <p className="italic" data-id="element-226">
              "Si tus alumnos no entienden física, no es por falta de capacidad.
              Es por falta de traducción conceptual. Y eso sí tiene solución."
            </p>
          </div>
        </div>
      </section>

      <footer className="bg-blue-950 text-blue-400 py-8 text-center text-sm" data-id="element-227">
        <p data-id="element-228">
          &copy; {new Date().getFullYear()} Física Sencilla. Todos los derechos
          reservados.
        </p>
      </footer>
    </div>;
}
// Helper component for icons
function CheckCircle2({
  className
}: {
  className?: string;
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-229">
      <circle cx="12" cy="12" r="10" data-id="element-230" />
      <path d="m9 12 2 2 4-4" data-id="element-231" />
    </svg>;
}